import { render, staticRenderFns } from "./infoConfig.vue?vue&type=template&id=97183a14&scoped=true&"
import script from "./infoConfig.vue?vue&type=script&lang=js&"
export * from "./infoConfig.vue?vue&type=script&lang=js&"
import style0 from "./infoConfig.vue?vue&type=style&index=0&id=97183a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97183a14",
  null
  
)

export default component.exports